import {
    provideHttpClient,
    withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RosaAuthService } from './services/auth/auth.service';
import { RosaCoreApiAuthService } from './services/auth/core-api-auth.service';
import { RosaCoreApiService } from './services/core-api.service';
import { RosaStoreService } from './services/store.service';
import { RosaAuthStoreEffects } from './store/auth/auth.effects';
import { authReducer } from './store/auth/auth.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature('auth', authReducer),
        EffectsModule.forFeature([RosaAuthStoreEffects])
    ],
    providers: [
        RosaStoreService,
        RosaAuthService,
        RosaCoreApiAuthService,
        RosaCoreApiService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class RosaCoreModule {}
